import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit, OnDestroy } from '@angular/core';
import { HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
.brand-logo {
  text-align: center;
}`],
})
export class ComponentNavSidebarComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public category: string = '';
    private routerSub: any;

    public categoryList: any[] = [
        { key: 'invest', title: '투자관리', color: 'blue' },
        { key: 'support', title: '지원사업', color: 'emerald' },
        { key: 'system', title: '관리시스템', color: 'violet' }
    ];

    public async ngOnInit() {
        this.detectCategory();
        await this.service.init();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                this.detectCategory();
                await this.service.render();
            }
        });
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private detectCategory() {
        const parts = location.pathname.split('/');
        if (parts.length >= 3 && parts[1] === 'admin') {
            const cat = parts[2];
            if (['invest', 'support', 'system'].includes(cat)) {
                this.category = cat;
            } else {
                this.category = '';
            }
        } else {
            this.category = '';
        }
    }

    public getCategoryTitle(): string {
        const found = this.categoryList.find(c => c.key === this.category);
        return found ? found.title : '관리자';
    }

    @HostListener('document:click')
    public clickout() {
        this.service.navbar.toggle(true);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "flex items-center gap-3 px-3 py-2 rounded-lg bg-zinc-100 text-zinc-900 text-sm font-medium transition-colors";
        }
        return "flex items-center gap-3 px-3 py-2 rounded-lg text-zinc-500 hover:text-zinc-900 hover:bg-zinc-50 text-sm font-normal transition-colors";
    }
}

export default ComponentNavSidebarComponent;